import { render, staticRenderFns } from "./WorkersReport.vue?vue&type=template&id=7ac6cf6a&"
import script from "./WorkersReport.vue?vue&type=script&lang=js&"
export * from "./WorkersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports